<template>
  <div>
    <Bio :extra="extra" :can-access-contact-informations="canAccessContactInformations" />
    <Experience :extra="extra" />
    <Skills :extra="extra" />
    <Education :extra="extra" />
  </div>
</template>

<script>
  import Bio from "@etab/components/extra/Bio.component.vue";
  import Experience from "@etab/components/extra/Experience.component.vue";
  import Skills from "@etab/components/extra/Skills.component.vue";
  import Education from "@etab/components/extra/Education.component.vue";
  import { GETTER_EXTRA_GET_CURRENT, GETTER_RECRUITMENT_GET_CURRENT } from "@etab/stores/types";
  import { ExtraService } from "@core/services";
  import { useExtraStore } from "@etab/stores/extra";
  import { useRecruitmentStore } from "@etab/stores/recruitment";
  import { mapStores } from "pinia";

  export default {
    components: {
      Bio,
      Experience,
      Education,
      Skills,
    },
    computed: {
      ...mapStores(useExtraStore, useRecruitmentStore),
      extra() {
        return this.extraStore[GETTER_EXTRA_GET_CURRENT];
      },
      recruitment() {
        return this.recruitmentStore[GETTER_RECRUITMENT_GET_CURRENT];
      },
      canAccessContactInformations() {
        return ExtraService.canAccessContactInformations({ extra: this.extra, recruitment: this.recruitment });
      },
    },
  };
</script>
